import { contentBlockSurface } from 'shared/assets/styles';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $fullSize: boolean; $grow: boolean }>`
  display: flex;
  flex-direction: column;

  ${contentBlockSurface};

  ${({ $fullSize }) =>
    $fullSize &&
    css`
      min-height: 0;
      flex: 1;
    `};

  ${({ $grow }) =>
    $grow &&
    css`
      flex-grow: 1;
    `};
`;

export const Header = styled.div<{ $hasBorder: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: red; */

  padding: ${({ theme, $hasBorder }) =>
    `${theme.spacing(3)} ${theme.spacing(3.5)} ${theme.spacing($hasBorder ? 3 : 0)} ${theme.spacing(5)}`};
  // height: 4.8rem;

  ${({ theme, $hasBorder }) =>
    $hasBorder &&
    css`
      border-bottom: 1px solid ${theme.palette.divider};
    `};
`;

export const SideArea = styled.div<{ $alignEnd?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;

  ${({ $alignEnd }) =>
    $alignEnd &&
    css`
      justify-content: flex-end;
    `};
`;

export const CenterInteractions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const TitleContainer = styled(QueryNavLink)`
  display: flex;
  align-items: center;

  text-decoration: none;
  color: inherit;
`;

export const ChevronContainer = styled.span`
  transform: rotate(180deg);

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Body = styled.div<{
  $hasTitle: boolean;
  $noPadding: boolean;
  $fill: boolean;
}>`
  flex: 1;

  // A grown card's height is indefinite to percentages, so pass it down as flex space.
  ${({ $fill }) =>
    $fill &&
    css`
      display: flex;
      flex-direction: column;
    `};
  padding: ${({ theme, $hasTitle, $noPadding }) =>
    $noPadding
      ? 0
      : $hasTitle
        ? `${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(5)}`
        : `${theme.spacing(5)} ${theme.spacing(5)} ${theme.spacing(5)}`};

  min-height: 0;
`;
